<template>
  <outer-landing-wrapper>
    <router-view v-if="loaded" />
    <error-view v-else-if="error" :error="error" @reload="load" />
    <vpreloader v-else width="2" size="64" />
  </outer-landing-wrapper>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ErrorView from '@/process/_components/error-view';
  import OuterLandingWrapper from '@/process/_components/outer-landing-wrapper';

  export default {
    name: 'InterviewTalentqDefault',

    components: {
      OuterLandingWrapper,
      ErrorView
    },

    computed: {
      ...mapGetters('interview_talentq', ['error', 'loaded', 'data'])
    },

    created() {
      this.load().then(() => {
        if (this.data.is_finished) {
          this.$router.push({ name: 'interview', params: this.$router.params });
        } else if (this.data.assessments.some(assessment => assessment.status.id !== 1)) {
          this.$router.push({ name: 'interview-talentq-choice-test', params: this.$router.params });
        }
      });
    },

    methods: {
      ...mapActions('interview_talentq', ['load'])
    }
  };
</script>
